import VehicleInfoGroupDetailModal from './vehicle-info-group-detail-modal.vue'
export default VehicleInfoGroupDetailModal
